import round from 'lodash/round';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import CustomSelect from '../common/CustomSelect';
import EmbeddedSelect from './EmbeddedSelect';
import EmbeddedRating from './EmbeddedRating';
import {formatProviderName,getProviderUrl} from '../../helpers/providers';
import {getSpecialties} from '../../helpers/selectOptions';

const ProviderSearchEmbedScreen = props => {
  const {filter, onFilterChange, providers, loading} = props;
  return (
    <Grid container padding='2em'>
      <Grid item xs={12}>
        <Typography 
          variant='h1' 
          component='h1' 
          padding={1}
          sx={{
            fontSize: '3rem', 
            fontWeight: 'bold', 
            fontFamily: 'Montserrat, sans-serif',
          }}
        >
          {filter.text ? 'Here\'s who we found' : 'Find a Physical Therapist'}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack direction='row' padding='1em' alignItems='center' spacing={1}>
          <input
            aria-invalid="false"
            class="MuiInputBase-input MuiOutlinedInput-input"
            type="text"
            data-testid="…"
            placeholder="Enter your city, zip, or a PT's name"
            style={{
              borderRadius: '2em',
              minWidth: '350px',
              height: '50px',
              fontSize: '1.1rem',
              border: '1px solid #ccc',
              padding: '0 1em',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              // on hover lighten the color
              transition: 'border-color 0.3s ease',
              outline: 'none',
            }}
            onChange={e => onFilterChange(e, {...filter, text: e.target.value})}
          />
          {/* <CustomTextField
            size='small'
            onChange={e => props.onFilterChange(e, {text: e.target.value})}
            placeholder="Enter your city, zip, or a PT's name"
            sx={{minWidth: 350, borderRadius: '10%'}}
            InputProps={{
              startAdornment: <InputAdornment position="start">
                <SearchIcon color='primary' />
              </InputAdornment>
            }}
          /> */}
        </Stack>
        {
          filter?.text &&
          <Grid item xs={12} sm={6} paddingLeft={1.5}>
            <CustomSelect
              options={getSpecialties()}
              placeholder="Filter by Specialty"
              style={{minWidth: '175px'}}
              onChange={(e, val) => onFilterChange(e, {...filter, specialty: e?.target?.value})}
            />
          </Grid>
        }
        {/* {
          filter?.text &&
          <Grid item xs={12} sm={6}>
            <CustomSelect
              options={[{value: 'all', label: 'All'}, {value: 'in-person', label: 'In-Person'}, {value: 'virtual', label: 'Virtual'}]}
              placeholder="Filter by Condition"
              style={{minWidth: '175px'}}
              onChange={(e, val) => onFilterChange(e, {...filter, visitType: val})}
            />
          </Grid>
        } */}
      </Grid>
      { filter.text && <Grid item xs={12}>
        <Typography
          variant='body1'
          padding={1.5}
          color='text.muted'
          sx={{fontSize: '1rem'}}
        >
          {
            providers?.length > 0
            ? 'Select a highly experienced MovementX physical therapist below.'
            : 'No providers found matching your search criteria.'
          }
        </Typography>
      </Grid>}
      {
        filter.text && (providers || []).map(p => 
          <Grid item xs={12} sm={12} md={12} lg={12} key={p.id} paddingTop='1em'>
            <Stack direction='row' spacing={2} paddingLeft='2em'>
              <img 
                src={p.imgSrc}
                alt={formatProviderName(p)} 
                style={{width: '100px', height: '100px', borderRadius: '10%'}}
              />
              <Stack spacing={1}>
                <Typography variant='h2' style={{minWidth: '250px'}}>
                  {formatProviderName(p)}
                </Typography>
                <Typography variant='body1' color='text.muted'>{`${p.city}, ${p.state}`}</Typography>
                <EmbeddedRating provider={p} />
              </Stack>
              <Stack spacing={.5}>
                <a href={`https://app.movement-x.com${getProviderUrl(p)}`} target='_blank' rel='noreferrer'>
                  <button
                    style={{
                      height: '50px',
                      padding: '0 1.5em',
                      borderRadius: '2em',
                      border: 'none',
                      backgroundColor: config().colors.primary,
                      color: '#fff',
                      fontSize: '1rem',
                      cursor: 'pointer',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      transition: 'background-color 0.3s ease',
                      outline: 'none',
                    }}
                  >
                    Book Now
                  </button>
                </a>
                <Typography style={{fontSize: '0.8rem', color: '#666'}} align='center'>
                  {p?.rate
                    ? `From $${round(p.rate / 2, 0)}`
                    : null
                  }
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        )
      }
    </Grid>
  );
};

export default ProviderSearchEmbedScreen;